import { Link } from 'react-router-dom';
import UpvoteControl from './UpvoteControl';
import { CategoryChip, GooderaPick } from './Chips';
import { timeAgo } from '@/lib/exchangeApi';

const PostCard = ({ post }) => (
  <div
    data-testid={`post-card-${post.id}`}
    className="flex gap-4 bg-white rounded-2xl border border-black/[0.06] shadow-sm p-4 md:p-5 hover:shadow-md hover:border-black/[0.12] transition-all"
  >
    <UpvoteControl postId={post.id} count={post.upvotes} />

    <div className="min-w-0 flex-1">
      <Link
        to={`/exchange/post/${post.id}`}
        data-testid={`post-title-link-${post.id}`}
        className="block font-bold text-ink text-lg leading-snug hover:text-brand-orange transition-colors"
      >
        {post.title}
      </Link>
      <p className="text-ink-secondary text-sm leading-snug mt-1 line-clamp-2">{post.description}</p>

      <div className="flex items-center flex-wrap gap-x-2 gap-y-1.5 mt-3 text-xs text-ink-muted">
        <CategoryChip category={post.category} />
        <span className="text-ink-secondary">
          by <span className="font-semibold text-ink">{post.display_name}</span> · {post.organization}
        </span>
        <span aria-hidden>·</span>
        <span>{timeAgo(post.created_at)}</span>
        {post.endorsed && <GooderaPick />}
      </div>
    </div>
  </div>
);

export default PostCard;
